import FakeApi from './fakeApi';
import RealApi from './realApi';
import config from './config';

export default config.useRealApi ? RealApi : FakeApi;


// WEBPACK FOOTER //
// ./src/js/serverApi/index.js